<div class="col-md-12  d-flex justify-content-center row  align-items-center mt-5">
  <div class="col-12 col-md-8 row  d-flex justify-content-center row  align-items-center ">
    <div class="col-3 col-md-2 d-flex justify-content-center">
      <img src="../../../assets/icons-web/no-result.png" style="width: 100%;" alt="">
    </div>
    <div class="col-8 col-md-4 d-flex justify-content-center">
      <p class="no-margin">No se encontraron resultados</p>
    </div>
  </div>